<template>
  <div id="page">
    <NavBar />

    <div class="sub_header_in sticky_header">
      <div class="container">
        <h1>{{ $t('lang.navbar.user_account') }}</h1>
      </div>
      <!-- /container -->
    </div>
    <!-- /sub_header -->
    <div
      v-if="showData"
      class="container margin_30"
    >
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-6 col-md-8">
          <div class="box_account">
            <h3 class="client">
              {{ $t('lang.account.sub_title') }}
            </h3>

            <label
              class="float-right pt-2"
              style="font-weight: normal"
            >{{ $t('lang.forms.required_field') }}</label>

            <div class="form_container">
              <Errors :errors="errors" />
              <Success :success-message="successMessage" />

              <div class="form-group">
                <input
                  id="email"
                  v-model="user.email"
                  type="email"
                  class="form-control"
                  name="email"
                  disabled
                >
              </div>
              <hr>

              <form @submit.prevent="saveUserData">
                <div class="private box">
                  <!--                  Profile Image -->
                  <div class="row no-gutters">
                    <div class="col-12">
                      <div class="form-group">
                        <label>{{ $t('lang.forms.image') }}</label>
                        <div class="form-group text-center align-middle">
                          <img
                            v-if="user.profile_image"
                            :src="user.profile_image"
                            class="profile-image"
                          >

                          <button
                            type="button"
                            class="btn btn-outline-primary center"
                            data-toggle="modal"
                            data-target="#profileImageModal"
                          >
                            {{ $t('lang.forms.edit') }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <hr>
                  <br>

                  <UserData
                    :user-data="user"
                    @fullNameError="userDataError"
                    @changes="updateUserData"
                  />
                  <br>
                  <div class="text-center">
                    <button
                      id="btn_submit"
                      type="submit"
                      class="btn_1 full-width"
                      name="btn_submit"
                      :disabled="!allowToSend || validated"
                    >
                      {{ $t('lang.forms.button_save') }}
                    </button>
                  </div>
                </div>
              </form>

              <div class="clearfix add_bottom_15">
                <div class="float-right mt-1">
                  <button
                    class="btn btn-link link-light"
                    data-toggle="modal"
                    data-target="#disableAccountModal"
                  >
                    {{ $t('lang.account.disabled_account') }}
                  </button>
                </div>
              </div>

              <div
                id="disableAccountModal"
                class="modal fade"
                tabindex="-1"
                role="dialog"
                aria-labelledby="disableAccountModal"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="card card-alert text-white bg-danger o-hidden h-100">
                      <div class="card-body">
                        <div class="card-body-icon">
                          <i class="icon-heart-broken" />
                        </div>
                        <div class="mr-5">
                          <h5>{{ $t('lang.account.disabled_account_alert') }}</h5>
                        </div>
                      </div>
                      <div class="card-footer bg-white text-center">
                        <button
                          type="button"
                          class="btn btn-outline-dark "
                          data-dismiss="modal"
                          @click="disableAccount"
                        >
                          {{ $t('lang.account.button_confirm') }}
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-danger"
                          data-dismiss="modal"
                        >
                          {{ $t('lang.account.button_cancel') }}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                id="profileImageModal"
                ref="profileImageModal"
                class="modal fade"
                tabindex="-1"
                role="dialog"
                aria-labelledby="profileImage"
                aria-hidden="true"
              >
                <div
                  class="modal-dialog modal-dialog-centered"
                  role="document"
                >
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">
                        {{ $t('lang.titles.profile_image') }}
                      </h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                      >
                        &times;
                      </button>
                    </div>

                    <div class="container text-center">
                      <CropProfileImage @update="saveCropImage" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /form_container -->
          </div>
          <!-- /box_account -->
        </div>
      </div>
      <!-- /row -->
    </div>
    <!-- /container -->

    <FooterComponent />
  </div>
</template>

<script>
import UserData from '@/components/User/UserData';
import NavBar from '../components/NavBar/NavBar';
import Errors from '../components/Alerts/Errors';
import Success from '../components/Alerts/Success';
import CropProfileImage from '../components/CropProfileImage';
import FooterComponent from '../components/FooterComponent';

import { API, errorResponse } from '../api/api';

const UserAPI = API.get('user');

export default {
  name: 'Account',
  components: {
    UserData,
    NavBar,
    CropProfileImage,
    Errors,
    Success,
    FooterComponent,
  },

  data() {
    return {
      user: {},
      showData: false,
      errors: {},
      successMessage: null,
      validated: false,
      newImageUpload: false,
      allowToSend: true,
    };
  },

  async created() {
    try {
      const { data } = await UserAPI.getUserData();
      this.user = data;

      this.showData = true;
    } catch (error) {
      this.errors = errorResponse(error);
    }
  },

  methods: {
    updateUserData(data) {
      const clave = Object.keys(data)[0];
      const newValue = Object.values(data)[0];
      this.user[clave] = newValue;
    },

    userDataError(value) {
      this.allowToSend = !value;
    },

    async saveUserData(e) {
      e.preventDefault();
      this.validated = true;
      this.errors = {};
      this.successMessage = null;
      const payloadUserData = {};

      try {
        for (const userItem in this.user) {
          if (this.user[userItem] != null) {
            payloadUserData[userItem] = this.user[userItem];
          }
        }

        await UserAPI.setUserData(payloadUserData);

        this.successMessage = this.$t('lang.alerts.save_success');

        await this.$store.dispatch('setDocType', this.user.doc_type);
      } catch (error) {
        this.validated = false;
        this.errors = errorResponse(error);
      }
      this.validated = false;
      window.scrollTo(0, 0);
    },

    async disableAccount() {
      this.validated = true;
      this.errors = {};

      try {
        await UserAPI.disableUser();
        // Clean storage
        this.$store.dispatch('removeUserData');
        this.$router.push('/');
      } catch (error) {
        this.validated = false;
        this.errors = errorResponse(error);
      }
      this.validated = false;
    },

    saveCropImage(imageData) {
      this.user.profile_image = imageData;
      this.newImageUpload = true;
    },

  },
};

</script>

<style scoped>

</style>
